const QUERY_WECHAT_SUBSCRIBE_MESSAGE_CONFIG = `
query wechatSubscribeMessageConfig(
  $advisor_type: WechatSubscribeMessageConfigAdvisorType!
) {
  wechat_subscribe_message_config(advisor_type: $advisor_type) {
    url
    title
    advisor_type
    advisor_name
    advisor_avatar_url
  }
}
`

const QUERY_LOTTERY_ACTIVITY = `
query WebLotteryActivity($customer_id: String, $lottery_activity_type: String!) {
    lottery_activity_v2(customer_id: $customer_id ,lottery_activity_type: $lottery_activity_type) {
      id
      started_at
      expired_at
      state
      join_state
      type
      title
      description
      lottery_activity_prizes {
        id
        thumb_image
      }
      customer_lottery_results {
        id
        lottery_activity_prize {
          id
          type
          image
          prize_item {
            ... on PromoCode {
              __typename
              charge_type
              subscription_type_ids
            }
            ... on Gift {
              __typename
              title
            }
            ... on SubscriptionType {
              __typename
              id
            }
          }
        }
      }
    }
  }`

const QUERY_LOTTERY_WIN_LIST = `
query WebLotteryWinList($customer_id: String) {
    lottery_win_list(customer_id: $customer_id)  {
      avatar_url
      nickname
      win_at
      lottery_activity_prize {
        id
        name
      }
    }
  }
  `

const MUTATION_REDEEM_YOUZAN_CODE = `
mutation redeemYouzanCode($input: RedeemYouzanCodeInput!) {
    RedeemYouzanCode(input: $input) {
      success
      errors
      exchange_name
      promo_code {
        code
        description
        discount_amount
        expiration_date
        type
        condition_display
        status
        title
        rules
        subscription_type_ids
      }
    }
  }`

const MUTATION_CUSTOMER_LOTTERY = `
mutation WebCustomerLottery($input: CustomerLotteryV2Input!) {
  CustomerLotteryV2(input: $input) {
    success
    errors {
      message
    }
    customer_lottery_result {
      lottery_activity {
        id
        started_at
        expired_at
        state
        join_state
        type
        title
        description
        lottery_activity_prizes {
          id
          thumb_image
        }
      }
      lottery_activity_prize {
        id
        type
        image
        popup_image
        prize_item {
          ... on PromoCode {
            __typename
            charge_type
            subscription_type_ids
          }
          ... on Gift {
            __typename
            title
          }
          ... on SubscriptionType {
            __typename
            id
          }
        }
      }
    }
    errors {
      error_code
      message
    }
    success
  }
}
`

const QUERY_COMMON_ACTIVITY = `
query QueryCommonActivity($common_activity_type: String!) {
  common_activity(common_activity_type: $common_activity_type) {
    id
    title
    state
    join_state
    customer_common_activity {
      state
      expected_settle_at
    }
  }
}
`

const MUTATION_CUSTOMER_COMMON_ACTIVITY = `
mutation CustomerCommonActivity($input: CustomerCommonActivityInput!) {
	CustomerCommonActivity(input: $input) {
    success
    errors {
      error_code
      message
    }
  }
}`

const MUTATION_GRANT_EXCHANGE_CARD = `
mutation GrantExchangeCard($input: GrantExchangeCardInput!) {
  GrantExchangeCard(input: $input) {
    code
    success
    errors {
      error_code
      message
    }
  }
}
`

export default {
  QUERY_WECHAT_SUBSCRIBE_MESSAGE_CONFIG,
  QUERY_LOTTERY_ACTIVITY,
  QUERY_LOTTERY_WIN_LIST,
  MUTATION_REDEEM_YOUZAN_CODE,
  MUTATION_CUSTOMER_LOTTERY,
  QUERY_COMMON_ACTIVITY,
  MUTATION_CUSTOMER_COMMON_ACTIVITY,
  MUTATION_GRANT_EXCHANGE_CARD
}
